import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

interface IDisplayMsg {
  msg: string;
  title: string;
  timeOut: number;
}

@Injectable()
export class MsgService {
  toastRef;
  removeToastIds = [];
  public static warningSubject = new Subject<IDisplayMsg>();

  constructor(private toastr: ToastrService) {
    MsgService.warningSubject.subscribe(displayMsg => {
      this.warning(displayMsg.msg, displayMsg.title, displayMsg.timeOut);
    });
  }

  // Angular Toastr表示：Success
  public success(msg: string, title: string, timeOut = 4000): void {
    this.toastRef = this.toastr.success(msg, title, {
      timeOut: timeOut,
      closeButton: true,
      progressBar: true
    });
    this.removeToastIds.push(this.toastRef.toastId);
  }

  // Angular Toastr表示：Info
  public info(msg: string, title: string, timeOut = 4000): void {
    this.toastRef = this.toastr.info(msg, title, {
      timeOut: timeOut,
      closeButton: true,
      progressBar: true
    });
    this.removeToastIds.push(this.toastRef.toastId);
  }

  // Angular Toastr表示：Warning
  public warning(msg: string, title: string, timeOut = 7000): void {
    this.toastRef = this.toastr.warning(msg, title, {
      timeOut: timeOut,
      closeButton: true,
      progressBar: true
    });
    this.removeToastIds.push(this.toastRef.toastId);
  }

  // Angular Toastr表示：Error
  public error(msg: string, title: string, timeOut = 30000): void {
    this.toastRef = this.toastr.error(msg, title, {
      timeOut: timeOut,
      closeButton: true,
      progressBar: true
    });
    this.removeToastIds.push(this.toastRef.toastId);
  }

  // Angular Toastr 画面内のものを全て消す（アニメーション有）
  public allRemove() {
    this.toastr.clear();
  }

  // Angular Toastr 削除対象(toastId配列に記録)のみ消す（アニメーション有）
  public remove() {
    for (const toastId of this.removeToastIds) {
      this.toastr.clear(toastId);
    }
    this.removeToastIds.length = 0;
  }

  // 削除対象のtoastId配列をリセット
  public clearRemoveToastIds() {
    this.removeToastIds.length = 0;
  }
}
